/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_SizesInputs */

const en_reference_field_sizes = /** @type {(inputs: Reference_Field_SizesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sizes, in order`)
};

/**
* | output |
* | --- |
* | "Sizes, in order" |
*
* @param {Reference_Field_SizesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_sizes = /** @type {((inputs?: Reference_Field_SizesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_SizesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_sizes(inputs)
});